// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".language-selector[data-v-9f538e3a]{position:absolute;top:1rem;right:1rem;padding:.3rem;font-size:1rem;border:1px solid #8f989b;border-radius:.5rem}", ""]);
// Exports
module.exports = exports;
